import { render } from "./invisible-circle.svg?vue&type=template&id=73add48e?inline"
const script = {}
script.render = render

export default script